import { Typography } from '@pocketlaw/tetris';
import styled from 'styled-components';
import { highlightStyles } from 'app/domains/global-search/components/styled';
export const StyledTypography = styled(Typography) `
  mark {
    ${highlightStyles}
  }
`;
